import { HTTP_AP_ListCases_ForLeadsTable_Request_Sort } from '@api-new/caseservice';
import { ENUM_AdvisorUserPermissionLevel } from '@api-new/common';
import { LeadCaseTableFilterModel } from '@platform/case/models/lead-case-table-filter.model';
import { LeadsTableRowModel } from '@platform/case/models/leads-table-row.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const leadCaseTableFilterDefaults: LeadCaseTableFilterModel = {
  createdAt: null,
  clientUserDisplayNameOrEmail: '',
  networkIds: [],
  companyIds: [],
  advisorUserDisplayNameOrEmail: '',
  caseType: null,
  mortgageExpiryTypes: null,
  loanAmount: { min: null, max: null },
  propertyValue: { min: null, max: null },
};

export const leadCaseTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
): TableRowDefinitionModel<LeadsTableRowModel, HTTP_AP_ListCases_ForLeadsTable_Request_Sort>[] => [
  {
    columnLabel: 'Client name',
    columnKey: 'clientUserDisplayName',
    sortKey: 'byClientUserDisplayName',
    isFrozen: true,
    type: RowDefinitionTypeEnum.FullnameShort,
    width: {
      min: '150px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Case type',
    columnKey: 'caseTypeMapped',
    sortKey: 'byCaseType',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '150px',
      max: '150px',
    },
  },
  {
    columnLabel: 'Id',
    columnKey: 'id',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'Company',
    columnKey: 'companyTradingName',
    sortKey: 'byCompanyTradingName',
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.CaseRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_COMPANY,
      },
    ]),
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Expiry type',
    columnKey: 'mortgageExpiryTypeMapped',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'Introducer',
    columnKey: 'affiliateName',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '150px',
      max: '150px',
    },
  },
  {
    columnLabel: 'Adviser',
    columnKey: 'advisorUserDisplayName',
    sortKey: 'byAdvisorUserDisplayName',
    type: RowDefinitionTypeEnum.FullnameInitials,
    width: {
      min: '85px',
      max: '85px',
    },
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.CaseRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_DIRECT,
      },
    ]),
  },
  {
    columnLabel: 'Loan amount',
    columnKey: 'loanAmount',
    sortKey: 'byLoanAmount',
    type: RowDefinitionTypeEnum.Currency,
    width: {
      min: '125px',
      max: '125px',
    },
  },
  {
    columnLabel: 'LTV',
    columnKey: 'ltv',
    type: RowDefinitionTypeEnum.Percent,
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'Property value',
    columnKey: 'propertyValue',
    sortKey: 'byPropertyValue',
    type: RowDefinitionTypeEnum.Currency,
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Created',
    columnKey: 'createdAt',
    sortKey: 'byCreatedAt',
    type: RowDefinitionTypeEnum.DateTimeSince,
    width: {
      min: '120px',
      max: '120px',
    },
  },
];
